import { Button, Form, FormInstance } from 'antd';

import { useCallback, useState } from 'react';
import FormFields from './components/CategoryFormFileds';
import styles from './index.module.scss';
import { CategoryCreate } from '../../Category/Create';

export interface CategoryCreateFormProps {
  onFinish: (formValue: CategoryCreate, file: any) => void;
  form: FormInstance<any>;
}

const CategoryCreateForm = ({ onFinish, form }: CategoryCreateFormProps) => {
  const [file, setFile] = useState('');

  const handleSetFile = useCallback((e: any) => {
    setFile(e.file);
  }, []);

  return (
  // eslint-disable-next-line no-shadow
    <Form className={styles.form} onFinish={(form: any) => onFinish(form, file)} form={form} autoComplete='off'>
      <FormFields handleSetFile={handleSetFile} />
    </Form>
  );
};

export default CategoryCreateForm;
